import axios from 'axios';
import {getAllMainGuests} from "../server/Api";

export const getMainGuestByEventId = async (eventId) => {
  if (!eventId) throw new Error("eventId is required");

  try {
    const response = await axios.get(getAllMainGuests(eventId));
    return response.data.data; // Assuming your API response is { data: [...] }
  } catch (error) {
    console.error("Error fetching guests:", error);
    throw error; // Let the caller handle error (e.g., toast in component)
  }
};